<ng-container *ngIf="!initialDataLoading; else loadingScreen">
  <h2 class="db-website-install__title">
    {{ 'text_wordpressInstallation' | dbText }}
  </h2>

  <div class="db-website-install__body">

    <db-create-website-options class="mb30"
                               *ngIf="canCreateMultisite || cloneAvailableWebsites?.length"
                               [canCreateMultisite]="canCreateMultisite"
                               [selectedMode]="createWebsiteMode"
                               [hasWebsite]="!!cloneAvailableWebsites?.length"
                               (modeSelected)="changeMode($event)"></db-create-website-options>

    <ng-container [ngSwitch]="createWebsiteMode">
      <db-create-website-install-clone *ngSwitchCase="'clone'"
                                       #cloneWebsiteRef
                                       [configHostname]="configHostname"
                                       [loading]="loading"
                                       [regions]="regions"
                                       [suggestedSubdomain]="suggestedSubdomain"
                                       [websites]="cloneAvailableWebsites"
                                       [userSubscription]="userSubscription"
                                       (submitted)="cloneSubmitted.emit($event)"
                                       (validationFailed)="loading = false"></db-create-website-install-clone>

      <db-create-website-install-blank *ngSwitchDefault
                                       #createWebsiteRef
                                       [loading]="loading"
                                       [configHostname]="configHostname"
                                       [suggestedSubdomain]="suggestedSubdomain"
                                       [createWebsiteMode]="createWebsiteMode"
                                       [regions]="regions"
                                       [userSubscription]="userSubscription"
                                       (resized)="changeModalSize()"
                                       (submitted)="createSubmitted.emit($event)"
                                       (validationFailed)="loading = false"></db-create-website-install-blank>
    </ng-container>

    <db-create-website-install-footer *ngIf="isMobile"
                                      [isClone]="createWebsiteMode === 'clone'"
                                      [loading]="loading"
                                      [hostedWebsitesCount]="hostedWebsitesCount"
                                      [hostedWebsitesLimit]="hostedWebsitesLimit"
                                      [userSubscription]="userSubscription"
                                      (submitted)="installWebsite()"></db-create-website-install-footer>

  </div>

  <db-create-website-install-footer *ngIf="isDesktop"
                                    [isClone]="createWebsiteMode === 'clone'"
                                    [loading]="loading"
                                    [hostedWebsitesCount]="hostedWebsitesCount"
                                    [hostedWebsitesLimit]="hostedWebsitesLimit"
                                    [userSubscription]="userSubscription"
                                    (submitted)="installWebsite()"></db-create-website-install-footer>

</ng-container>

<ng-template #loadingScreen>
  <db-loading-screen [pageBlocker]="true"></db-loading-screen>
</ng-template>
